import { Loading, useUser } from '@cibo/profile'
import { Markdown } from '@cibo/ui'
import { Box, Button, Divider, Grid, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AgreementNotes } from '../AgreementNotes'
import { AgreementResetButton } from '../AgreementResetButton'
import { useAgreement, useAgreementCopy } from '../queries'
import { AgreementDetailProps } from '../types'

export const DataValidationDetail = ({
  agreementId,
  setActionModal,
  downloadButton,
  fileDownloaded,
  markdownOverrides,
}: AgreementDetailProps) => {
  const { t } = useTranslation([
    'impact/pages/Agreements/DataValidationDetail',
    'impact/pages/Agreements',
  ])
  const agreement = useAgreement(agreementId)
  const user = useUser()
  const agreementCopy = useAgreementCopy(agreementId)

  if (agreement.isLoading || user.isLoading) {
    return <Loading />
  }

  const ownsAgreement = agreement.data && user.data?.matchUserId(agreement.data.userId)
  return (
    <Grid container>
      <Grid container spacing={6}>
        <Grid item md={7} xs={12}>
          <Stack spacing={3} paddingRight={2} alignItems="flex-start">
            <Markdown overrides={markdownOverrides}>{agreementCopy}</Markdown>
            <Box>{downloadButton}</Box>
            <Divider variant="fullWidth" />
            <AgreementResetButton
              agreementId={agreementId}
              ownsAgreement={ownsAgreement}
              setActionModal={setActionModal}
            />
            {ownsAgreement &&
              agreement.data?.status !== 'agreed' &&
              agreement.data?.isAllowed('can_agree') && (
                <Stack direction="row" spacing={2}>
                  <Button
                    data-testid="decline-data-validation"
                    variant="outlined"
                    color="error"
                    onClick={() => setActionModal({ open: true, action: 'declined' })}
                    disabled={!fileDownloaded || agreement.data?.status !== 'pending'}
                  >
                    {t('declinedButton')}
                  </Button>
                  <Button
                    data-testid="accept-data-validation"
                    variant="outlined"
                    color="success"
                    onClick={() => setActionModal({ open: true, action: 'agreed' })}
                    disabled={!fileDownloaded}
                  >
                    {t('acceptButton')}
                  </Button>
                </Stack>
              )}
          </Stack>
        </Grid>
        <Grid item md={5} xs={12}>
          <AgreementNotes agreementId={agreementId} />
        </Grid>
      </Grid>
    </Grid>
  )
}
